import React from "react"
import { useFormContext } from "react-hook-form"
import { Section, SingleShorty, TwoColumnRow } from "./Shared"
import L10n from "../../../lib/carrot-l10n"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { CompleteFormSelect } from "components/views/atoms/forms/FormSelect"
import SexChoices from "content/SexChoices"
import GenderIdentityChoices from "content/GenderIdentityChoices"
import { regexes } from "utils/Regexes"
import { Button } from "components/views/atoms/buttons/Button"
import { Spacer } from "components/views/atoms/Atoms"
import { useToggle } from "utils/Hooks"
import { UpdatePhoneNumberModal } from "components/views/account/phoneNumberUpdate/UpdatePhoneNumberModal"
import { useSelector } from "react-redux"
import { getUserInfo } from "reducers/userInfo"
import { getIsMemberOfCarrotCardCompany } from "derivedSelectors"
import { FeatureGate } from "utils/FeatureGate"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const FirstName = () => {
  const { errors, register } = useFormContext()

  return (
    <CompleteFormInput
      disabled
      name="firstName"
      label={l`client.accountSettings.firstNameLabel`}
      errors={errors}
      ref={register}
    />
  )
}

const LastName = () => {
  const { errors, register } = useFormContext()

  return (
    <CompleteFormInput
      disabled
      name="lastName"
      label={l`client.accountSettings.lastNameLabel`}
      errors={errors}
      ref={register}
    />
  )
}

const Email = () => {
  const { errors, register } = useFormContext()

  return (
    <CompleteFormInput
      name="email"
      label={l`client.accountSettings.emailLabel`}
      errors={errors}
      disabled
      ref={register}
    />
  )
}

const PersonalEmail = () => {
  const { errors, register } = useFormContext()

  return (
    <CompleteFormInput
      name="personalEmail"
      label={l`Preferred contact email`}
      errors={errors}
      ref={register({
        pattern: {
          value: regexes.email,
          message: l`client.invalidEmail`
        }
      })}
    />
  )
}

const Sex = () => {
  const { errors, register } = useFormContext()

  return <CompleteFormSelect name="sex" label={l`Sex`} ref={register} options={SexChoices} errors={errors} />
}

const GenderIdentity = () => {
  const { errors, register } = useFormContext()

  return (
    <CompleteFormSelect
      name="genderIdentity"
      label={l`Gender Identity`}
      ref={register}
      options={GenderIdentityChoices}
      errors={errors}
    />
  )
}

const DateOfBirth = () => {
  const { errors, register } = useFormContext()

  return (
    <CompleteFormInput
      type="date"
      name="dateOfBirth"
      label={l`client.accountSettings.dateOfBirthLabel`}
      errors={errors}
      ref={register}
      placeholder="mm/dd/yyyy"
    />
  )
}

const PhoneNumber = () => {
  const [showPhoneNumberModal, toggleShowPhoneNUmberModal] = useToggle(false)
  const { register } = useFormContext()

  return (
    <SingleShorty>
      <CompleteFormInput type="text" name="phoneNumber" label={l`Phone number`} ref={register} readOnly />

      <Button onClick={toggleShowPhoneNUmberModal} outline>
        {l`Update phone number`}
      </Button>
      <Spacer height={0.75} />
      {showPhoneNumberModal && <UpdatePhoneNumberModal onExit={toggleShowPhoneNUmberModal} />}
    </SingleShorty>
  )
}

const PersonalInformation = () => {
  const { hasCardholderId } = useSelector(getUserInfo)
  const isMemberOfCarrotCardCompany = useSelector(getIsMemberOfCarrotCardCompany)

  return (
    <Section title="Personal information">
      <TwoColumnRow left={<FirstName />} right={<LastName />} />
      <TwoColumnRow left={<Email />} right={<PersonalEmail />} />
      <SingleShorty>
        <DateOfBirth />
      </SingleShorty>
      <TwoColumnRow
        left={<Sex />}
        right={
          <FeatureGate filter={(c) => c.isLgtbqEnabled}>
            <GenderIdentity />
          </FeatureGate>
        }
      />
      {isMemberOfCarrotCardCompany && hasCardholderId && (
        <SingleShorty>
          <PhoneNumber />
        </SingleShorty>
      )}
    </Section>
  )
}

export default PersonalInformation
